/**
 * Централизованная утилита для логирования
 * Локальные логи в консоль (без отправки на backend)
 */

// 🔧 НАСТРОЙКА ЛОГОВ: измените на true чтобы включить логи
const ENABLE_LOGS = true;

// Отключено: отправка логов на backend удалена по запросу

export const logger = {
  log: (...args: any[]) => {
    if (ENABLE_LOGS) {
      console.log(...args)
    }
  },
  
  warn: (...args: any[]) => {
    if (ENABLE_LOGS) {
      console.warn(...args)
    }
  },
  
  error: (...args: any[]) => {
    if (ENABLE_LOGS) {
      console.error(...args)
    }
  },
  
  debug: (...args: any[]) => {
    if (ENABLE_LOGS) {
      console.debug(...args)
    }
  },
  
  info: (...args: any[]) => {
    if (ENABLE_LOGS) {
      console.info(...args)
    }
  },
  
  isEnabled: () => ENABLE_LOGS
}